import { render, staticRenderFns } from "./AwardsSwiper.vue?vue&type=template&id=0b98d8f5&scoped=true&"
import script from "./AwardsSwiper.vue?vue&type=script&lang=js&"
export * from "./AwardsSwiper.vue?vue&type=script&lang=js&"
import style0 from "./AwardsSwiper.vue?vue&type=style&index=0&id=0b98d8f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b98d8f5",
  null
  
)

export default component.exports